import {
  ISearchRegionsCitiesResponse200,
  TSearchRegionsCitiesResponse,
} from '../../../repositories/monolith-python/v1/search-regions-cities';
import { ResponseError } from '../../../utils/errors';

export function assertResponseError(
  response: TSearchRegionsCitiesResponse,
): asserts response is ISearchRegionsCitiesResponse200 {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new ResponseError({
    domain: 'shared/services/searchRegions/regionSuggests#assertResponseError()',
    message: 'Failed loading regions searching results',
    details: { message, errors },
  });
}
